<template>

    <b-form @submit.prevent="submitQueryAnswerType" autocomplete="off">

        <b-row>

            <b-col sm="12" md="7">

                <b-row>

                    <b-form-group class="w-100">
                        <label for="query"><strong>Consulta *</strong></label>
                        <b-form-textarea
                            required
                            id="query"
                            rows="3"
                            v-model="queryAnswerTypeItem.query">
                        </b-form-textarea>
                    </b-form-group>

                </b-row>

                <b-row>

                    <b-form-group class="w-100">
                        <label for="answer"><strong>Respuesta *</strong></label>
                        <b-form-textarea
                            required
                            id="answer"
                            rows="3"
                            v-model="queryAnswerTypeItem.answer">
                        </b-form-textarea>
                    </b-form-group>

                </b-row>

            </b-col>

            <b-col sm="12" md="5">

                <label><strong>Categorias *</strong></label>
                <treeselect
                    required
                    instanceId="categories"
                    v-show="queryCategoriesTreeData.length > 0"
                    v-model="queryAnswerTypeItem.categories"
                    :multiple="true"
                    :clearable="false"
                    placeholder="Selecciona las categorias"
                    :options="queryCategoriesTreeData"/>

                <div class="w-100 mt-5 text-right">
                    <label><strong>Activa</strong></label>
                    &nbsp;
                    <toggle-button
                        class="mt-1"
                        color="#025542"
                        :sync="true"
                        v-model="queryAnswerTypeItem.active"
                        :labels="{checked: 'Si', unchecked: 'No'}"/>
                </div>

                <div class="mt-5">

                    <p v-if="queryAnswerTypeItem.createdBy" class="text-right m-0">
                        Creado por &nbsp;<strong>{{queryAnswerTypeItem.createdBy}}</strong>&nbsp; el día &nbsp;<strong>{{queryAnswerTypeItem.createdAt | dateFormat('DD/MM/YYYY')}}</strong>
                    </p>

                    <p v-if="queryAnswerTypeItem.updatedBy" class="text-right m-0">
                        Actualizado por &nbsp;<strong>{{queryAnswerTypeItem.updatedBy}}</strong>&nbsp; el día &nbsp;<strong>{{queryAnswerTypeItem.updatedAt | dateFormat('DD/MM/YYYY')}}</strong>
                    </p>

                </div>

            </b-col>

        </b-row>

        <b-row class="mt-2">
            <div class="w-100 d-flex justify-content-between align-items-center m-0 px-3">
                <div>
                    <button
                        type="button"
                        class="btn btn-brand btn-danger btn-lg"
                        v-if="renderDeleteButton"
                        @click="deleteQueryAnswerType">
                        Eliminar
                    </button>
                </div>
                <div>
                    <button
                        type="submit"
                        class="btn btn-brand btn-primary btn-lg"
                        v-if="renderSaveButton">
                        Guardar
                    </button>
                </div>
            </div>
        </b-row>

    </b-form>
</template>

<script>

    import '@riophae/vue-treeselect/dist/vue-treeselect.css'
    import Treeselect from '@riophae/vue-treeselect';
    import {getQueryCategoriesTreeSimple} from '@/api/query-category-api';

    export default {
        name: "QueryAnswerTypeForm",
        components: { Treeselect },
        props: [
            'queryAnswerType',
            'renderDeleteButton',
            'renderSaveButton'
        ],
        data: function () {
            return {
                queryAnswerTypeItem: {
                    uuid: null,
                    createdBy: null,
                    createdAt: null,
                    updatedBy: null,
                    updatedAt: null,
                    query: null,
                    answer: null,
                    categories: [],
                    active: true
                },
                queryCategoriesTreeData: [],
            };
        },

        mounted() {
            this.loadQueryAnswerTypeItem();
            this.loadQueryCategories();
        },

        methods: {

            loadQueryAnswerTypeItem() {
                if (this.queryAnswerType) {
                    this.queryAnswerTypeItem = {
                        uuid: this.queryAnswerType.uuid,
                        createdBy: this.queryAnswerType.createdBy,
                        createdAt: this.queryAnswerType.createdAt,
                        updatedBy: this.queryAnswerType.updatedBy,
                        updatedAt: this.queryAnswerType.updatedAt,
                        query: this.queryAnswerType.query,
                        answer: this.queryAnswerType.answer,
                        categories: this.parseSelectedCategories(this.queryAnswerType.categories),
                        active: this.queryAnswerType.active
                    }
                }
            },

            parseSelectedCategories(queryAnswerTypeCategories) {
                if (queryAnswerTypeCategories === undefined || queryAnswerTypeCategories.length === 0) {
                    return;
                }
                let selectedCategories = [];
                queryAnswerTypeCategories.forEach((queryAnswerTypeCategory) => {
                   selectedCategories.push(queryAnswerTypeCategory.uuid);
                });
                return selectedCategories;
            },

            loadQueryCategories() {
                getQueryCategoriesTreeSimple()
                    .then((queryCategoriesTree) => {
                        this.queryCategoriesTreeData = this.buildTreeData(queryCategoriesTree);
                    });
            },

            buildTreeData(queryCategoriesTree) {

                let treeData = [];

                queryCategoriesTree.forEach((category) => {

                    let node = {
                        id: category.uuid,
                        label: category.name,
                    };

                    if (category.children.length > 0) {
                        node['children'] = this.buildTreeData(category.children);
                    }

                    treeData.push(node);
                });

                return treeData;
            },

            submitQueryAnswerType() {
                this.$emit('submit-query-answer-type', this.queryAnswerTypeItem);
            },

            deleteQueryAnswerType() {
                this.$emit('delete-query-answer-type');
            }
        }
    }

</script>

<style>
    .vue-treeselect__multi-value-item {
        color: white;
        background: #025542;
    }
    .vue-treeselect__checkbox--indeterminate {
        border-color: #039be5;
        background: #039be5;
    }
    .vue-treeselect__checkbox--checked, .vue-treeselect__checkbox--indeterminate {
        border-color: #025542;
        background: #025542;
    }
    .vue-treeselect__value-remove {
        color: white;
    }
    .vue-treeselect__multi-value-item:hover .vue-treeselect__value-remove {
        color: white;
    }
</style>